<template>
  <ErrorReport />
</template>

<script>

import ErrorReport from '@/views/components/error-report.vue';

export default {
  name: 'ApplicationAnalysisErrorReport',
  components: {
    ErrorReport,
  },
};
</script>
